import React from 'react'

import { ReactComponent as UserAvatarIcon } from 'assets/svg/recents/user_avatar.svg'

export const CallAvatar = () => (
    <div className="call__avatar d-flex align-items-center justify-content-center">
        <UserAvatarIcon />
    </div>
)
